import { createSlice } from "@reduxjs/toolkit";

export const editingSlice = createSlice({
    name: "editingOptions",
    initialState: {
        activeCreateFeatureTool: "map",
        currentEditFeature: null,
        currentEditLayer: null,
        currentEditRelatedRecordInfo: null,
        /**
         *
         * @param {object} record _data from related record
         */
        currentEditRelatedRecordData: null,
    },
    reducers: {
        setActiveCreateFeatureTool: (state, action) => {
            state.activeCreateFeatureTool = action.payload;
        },
        editFeature: (state, action) => {
            state.currentEditFeature = action.payload.featureId;
            state.currentEditLayer = action.payload.layerId;
            state.activeCreateFeatureTool = "editfeature";
        },
        cloneFeature: (state, action) => {
            state.currentEditFeature = action.payload.featureId;
            state.currentEditLayer = action.payload.layerId;
            state.activeCreateFeatureTool = "clonefeature";
        },
        clearEdits: (state, action) => {
            state.currentEditFeature = undefined;
            state.currentEditLayer = undefined;
            state.activeCreateFeatureTool = "map";
        },
        editRelatedRecord: (state, action) => {
            state.currentEditRelatedRecordInfo = action.payload.RelatedRecordInfo;
            state.currentEditRelatedRecordData = action.payload.RelatedRecordData;
        },
        setCurrentEditRelatedRecordInfo: (state, action) => {
            state.currentEditRelatedRecordInfo = action.payload.RelatedRecordInfo;
        },
        setCurrentEditRelatedRecordData: (state, action) => {
            state.currentEditRelatedRecordData = action.payload.RelatedRecordData;
        },
        clearRelatedRecordEdits: (state, action) => {
            state.currentEditRelatedRecordInfo = undefined;
            state.currentEditRelatedRecordData = undefined;
        },
    },
});

export const {
    setActiveCreateFeatureTool,
    editFeature,
    cloneFeature,
    clearEdits,
    editRelatedRecord,
    setCurrentEditRelatedRecordInfo,
    setCurrentEditRelatedRecordData,
    clearRelatedRecordEdits,
} = editingSlice.actions;
export default editingSlice.reducer;
